const escolas_com_turmas_sem_estrutura_curricular = {
  path: "/relatorio-de-apoio-gerencial-escolas-com-turmas-sem-estrutura-curricular",
  redirect:
    "/relatorio-de-apoio-gerencial-escolas-com-turmas-sem-estrutura-curricular",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Turma",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-escolas-com-turmas-sem-estrutura-curricular",
      name: "relatorio-de-apoio-gerencial-escolas-com-turmas-sem-estrutura-curricular",
      meta: {
        allowedPermissions: ["listagem_escola_sem_estrutura_curricular"],
      },
      component: () =>
        import(
          "@/views/RelatorioEscolaComTurmaSemEstrutura/RelatorioEscolaComTurmaSemEstrutura.vue"
        ),
    },
  ],
};

export { escolas_com_turmas_sem_estrutura_curricular };
